import { render, staticRenderFns } from "./AlertSwiper.vue?vue&type=template&id=01d889fb&scoped=true&"
import script from "./AlertSwiper.vue?vue&type=script&lang=js&"
export * from "./AlertSwiper.vue?vue&type=script&lang=js&"
import style0 from "./AlertSwiper.vue?vue&type=style&index=0&id=01d889fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d889fb",
  null
  
)

export default component.exports